import React, { useState, useEffect } from "react"
import { Col, Row } from "reactstrap"
import { useLanguage } from "context/LanguageProvider"
import { useDarkMode } from "context/DarkModeProvider"
import "../assets/css/colors.css"
import { sendFeedback } from "apiHandles/user_progress"
import "../assets/css/feedback.css"

const FeedBackPage = () => {
    const { darkMode } = useDarkMode();
    const { selLanguage } = useLanguage();

    const [feedback, setFeedback] = useState("");
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(false);
    const [message, setMessage] = useState("");
    const [error, settError] = useState(false);

    useEffect(() => {
        if (message) {
            setFeedback("")
            const timer = setTimeout(() => {
                setMessage("");
                settError(false);
                setStatus(false);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [message]);


    const handleSubmit = async () => {
        setStatus(false);

        if (!feedback.trim()) {
            setMessage(selLanguage ? "Γράψτε ένα σχόλιο πρώτα για να το υποβάλετε." : "Write a feedback first to submit.");
            settError(true);
            return;
        }

        try {
            const res = await sendFeedback(feedback);

            if (res.success) {
                setStatus(true);
                setMessage(selLanguage ? "Ευχαριστούμε για το σχόλιο σου!" : "Thank you for your comment!");
            } else {
                setStatus(false);
                settError(true);
                setMessage(selLanguage ? "Υπήρξε ένα πρόβλημα. Προσπαθήστε ξανά αργότερα." : "A problem occured. Please try again later.")
            }
        } catch (err) {
            setStatus("error");
        }
    };

    return (
        <Col
            className="feedbackCol"
            xs="12" sm="12" md="12" lg="12" xl="12"
            style={{
                background: darkMode ? "#1E293B" : "var(--lightModeBack)",

            }}>

            <Row style={{ marginBottom: "20px" }}>
                <p
                    className="feedbackMessage"
                    style={{
                        color: darkMode ? "#fff" : "#181717ff"
                    }}
                >
                    {selLanguage
                        ? "Παρακαλώ επισημάνετε τυχόν σημεία που χρήζουν διόρθωσης ή βελτίωσης, καθώς και οποιαδήποτε πρόταση για προσθήκη."
                        : "Please note anything you think needs correction or improvement, or if you have any ideas for additions."
                    }
                </p>
            </Row>

            <div style={{
                flex: 1,
                display: "flex",
                padding: "0 8px",
                paddingBottom: "16px"
            }}>
                <textarea
                    className="feedbackTextArea"
                    placeholder={selLanguage ? "Γράψτε το σχόλιό σας εδώ..." : "Write your feedback here..."}
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    style={{
                        border: `1px solid ${darkMode ? "#475569" : "#CBD5E1"}`,
                        background: darkMode ? "#0F172A" : "#FFFFFF",
                        color: darkMode ? "#E2E8F0" : "#1E293B",
                    }}
                    onFocus={(e) => {
                        e.target.style.borderColor = "#3b82f6";
                        e.target.style.boxShadow = `0 0 0 3px ${darkMode ? "rgba(59, 130, 246, 0.1)" : "rgba(59, 130, 246, 0.1)"}`;
                    }}
                    onBlur={(e) => {
                        e.target.style.borderColor = darkMode ? "#475569" : "#CBD5E1";
                        e.target.style.boxShadow = "none";
                    }}
                />
            </div>

            {message &&
                <div
                    style={{
                        maxWidth: '700px',
                        margin: '0 auto 20px',
                        padding: '15px 20px',
                        background: error ? "linear-gradient(135deg, #ef4444 0%, #dc2626 20%)" : 'linear-gradient(135deg, #187e42ff 0%, #19830bff 20%)',
                        borderRadius: '15px',
                        color: 'white',
                        fontSize: '0.95rem',
                        lineHeight: '1.5',
                        boxShadow: error ? '0 8px 20px rgba(239, 68, 68, 0.4)' : '0 4px 20px rgba(97, 239, 68, 0.4)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        alignContent: "center",
                        justifyContent: "center"
                    }}>
                    {message}
                </div>
            }

            <button
                onClick={handleSubmit}
                disabled={loading}
                style={{
                    width: "100px",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "center",
                    marginLeft: "auto",
                    border: "none",
                    borderRadius: "10px",
                    background: loading
                        ? "gray"
                        : "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                    color: "#fff",
                    cursor: loading ? "not-allowed" : "pointer",
                    padding: "8px 0"
                }}>
                {loading
                    ? (selLanguage ? "Αποστολή..." : "Sending...")
                    : (selLanguage ? "Υποβολή" : "Submit")
                }
            </button>
        </Col>
    )
}

export default FeedBackPage
